import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/rematch.vue
var o = {
	name: "DtIconRematch",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--rematch"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Rematch",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 2a3.877 3.877 0 0 0-3.877 3.877.5.5 0 1 1-1 0A4.877 4.877 0 0 1 6 1h.002a5.242 5.242 0 0 1 3.624 1.473l.006.006.245.245V1.5a.5.5 0 1 1 1 0v2.432a.5.5 0 0 1-.5.5H7.945a.5.5 0 0 1 0-1H9.17l-.242-.243a4.242 4.242 0 0 0-2.929-1.19Zm4.377 3.623a.5.5 0 0 1 .5.5A4.877 4.877 0 0 1 6 11h-.002a5.242 5.242 0 0 1-3.624-1.473l-.006-.006-.245-.246V10.5a.5.5 0 0 1-1 0V8.068a.5.5 0 0 1 .5-.5h2.431a.5.5 0 0 1 0 1H2.83l.242.243A4.242 4.242 0 0 0 6.001 10a3.877 3.877 0 0 0 3.876-3.878.5.5 0 0 1 .5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=rematch.js.map